import React, { useEffect, useState, useRef } from "react";
import { BgButton } from "../../UI/register";
import { css } from "styled-components/macro";
import ResendBTN from "./resendBtn";
import fetchModule from "../../../utils/fetchingData";
import lstool from "../../../utils/localStorage";
import { toast } from "react-toastify";
import API from "./../../../configs/API";
import { createSendForm } from "../../../utils/form";
function ResendVerify() {
  const endPoint = new Date(new Date().getTime() + 60 * 10000).getTime();
  const [state, setState] = useState({ status: "countdown", time: "" });
  useEffect(() => {
    let Timer = setInterval(() => {
      let distance = endPoint - new Date().getTime();
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = ("0" + Math.floor((distance % (1000 * 60)) / 1000)).slice(
        -2
      );
      if (minutes <= 0 && seconds <= 0) {
        setState({ time: "0:00", status: "active" });
        clearInterval(Timer);
      } else {
        setState({ ...state, time: `${minutes}:${seconds}` });
      }
    }, 1000);
    return () => {
      clearInterval(Timer);
    };
  }, []);
  const ReSend = async () => {
    try {
      let response = await fetchModule.post(
        "",
        createSendForm(
          { type: API.setPhone, mobilenumber: lstool.get("phone") },
          false,
          "multiPart"
        )
      );
      if (response === "true") {
        setState({ time: "", status: "blocked" });
      }
    } catch (error) {
      toast.error("مشکلی پیش آمده.دوباره تلاش کنید");
    }
  };
  return state.status === "blocked" ? null : (
    <ResendBTN {...state} click={ReSend}></ResendBTN>
  );
}
export default ResendVerify;
